export default __webpack_public_path__ + "static/hero-contact-299092adb7c0a6ea258264806bc157d4.png";